import React from 'react';
import { usePremiumListingsOptions } from '@app/hooks/nft/usePremiumListingsOptions';
import { Box, HStack, Text } from '@chakra-ui/react';
import { TokensPair } from '@app/components/TokensPair';
import { useNftMarketplaceFiltersState } from '@app/state/nftMarketplaceFiltersStore';

export const PremiumListingsFilter = () => {
  const { data } = usePremiumListingsOptions();
  const {
    premiumNftView,
    actions: { setPremiumNftView }
  } = useNftMarketplaceFiltersState();

  if (!data || !data.length) {
    return null;
  }

  return (
    <Box
      mb={3}
      sx={{
        border: '1px solid',
        borderColor: 'neutral.700',
        padding: 3,
        borderRadius: '8px',
        width: '100%'
      }}
    >
      <Text color="neutral.200" fontWeight={500} mb={2} fontSize={16}>
        Premium NFTs available
      </Text>
      <HStack>
        {data?.map(item => {
          const isSelected = premiumNftView === item.nftContractAddress;

          return (
            <HStack
              key={item.nftContractAddress}
              sx={{
                border: '1px solid',
                borderColor: isSelected ? 'premium' : 'neutral.700',
                backgroundColor: isSelected
                  ? 'premiumOpacity.1'
                  : 'transparent',
                padding: '8px 12px',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              _hover={{
                filter: 'brightness(120%)',
                borderColor: 'premium'
              }}
              onClick={() =>
                setPremiumNftView(isSelected ? '' : item.nftContractAddress)
              }
            >
              <TokensPair
                token0Symbol={item.token0.symbol}
                token1Symbol={item.token1.symbol}
              />
              <Text>
                {item.token0.symbol}-{item.token1.symbol}
              </Text>
            </HStack>
          );
        })}
      </HStack>
    </Box>
  );
};
